import { Alert, Snackbar } from "@mui/material";
import { useNotificationStore } from "../model/store";
import CheckIcon from "@mui/icons-material/Check";

export const Notification = () => {
  const { message, type, isVisible, hide } = useNotificationStore();

  return (
    <Snackbar
      open={isVisible}
      autoHideDuration={3000}
      onClose={hide}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert
        onClose={hide}
        severity={type}
        variant="filled"
        {...(type === "success" && {
          icon: <CheckIcon />,
        })}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};
